import { 
    grabModifiedDutyEmployees, 
    addModifiedDutyEmployee, 
    changeModifiedDutyEmployee 
} from "../dataLayer/modifiedDuty";
import { 
    ModifiedDutyEmployee, 
    CreateModifiedDutyEmployeeRequest, 
    UpdateModifiedDutyEmployeeRequest,
    ModifiedDutySaveResponse
} from "../interfaces/ModifiedDutyInterface";

class ModifiedDutyManager {
    async getModifiedDutyEmployees(): Promise<ModifiedDutyEmployee[]> {
        const data: ModifiedDutyEmployee[] = await grabModifiedDutyEmployees();
        return data;
    }

    async addModifiedDutyEmployee(
        newModifiedDutyEmployee: CreateModifiedDutyEmployeeRequest
    ): Promise<ModifiedDutySaveResponse> {
        const response = await addModifiedDutyEmployee(newModifiedDutyEmployee);
        return response;
    }

    async editModifiedDutyEmployee(
        id: number,
        updatedModifiedDutyEmployee: UpdateModifiedDutyEmployeeRequest
    ): Promise<ModifiedDutySaveResponse> {
        const response = await changeModifiedDutyEmployee(id, updatedModifiedDutyEmployee);
        return response;
    }
}

export default new ModifiedDutyManager();

